import React from 'react';
import './ComboIndicator.css';

// Purely a reflection of THIS session's own answer stream (consecutive
// correct answers so far, computed by the caller from real graded state —
// never a second source of truth). Only meaningful where instant feedback is
// already on, since combo requires knowing right/wrong immediately.
const ComboIndicator = ({ combo }) => {
  if (!combo || combo < 2) return null;
  return (
    <div className="z-combo" role="status">
      <span className="z-combo-label">COMBO</span>
      <span className="z-combo-num">×{combo}</span>
    </div>
  );
};

export default ComboIndicator;
